/* Focus Hack — flèches des rails tactiles.

   Pilote les deux rails mobiles, les kits et les avis. Un clic déplace le
   rail d'exactement une carte, gouttière comprise, et laisse l'accrochage
   CSS terminer l'alignement.

   Le swipe au doigt reste la voie principale : ce script n'ajoute que deux
   boutons. Aucune bibliothèque, aucun défilement automatique, aucun
   minuteur, aucune modification du balisage.

   Les états inactifs sont recalculés à chaque défilement, qu'il vienne d'un
   clic ou du doigt.
*/

(function () {
  var MOINS_DE_MOUVEMENT = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* Le pas réel : distance d'une carte à la suivante, gouttière incluse.
     Mesuré dans le document plutôt que supposé, pour rester juste quelle que
     soit la largeur d'écran. */
  function pas(piste) {
    var premiere = piste.children[0];
    var seconde = piste.children[1];
    if (!premiere) return piste.clientWidth;
    if (seconde) {
      return Math.round(
        seconde.getBoundingClientRect().left - premiere.getBoundingClientRect().left
      );
    }
    return Math.round(premiere.getBoundingClientRect().width);
  }

  function brancher(rail) {
    if (rail.dataset.fhRailPret) return;

    var piste = rail.querySelector('[data-fh-rail-piste]');
    var prec = rail.querySelector('[data-fh-rail-prec]');
    var suiv = rail.querySelector('[data-fh-rail-suiv]');
    if (!piste || !prec || !suiv) return;

    rail.dataset.fhRailPret = '1';

    function maj() {
      var course = piste.scrollWidth - piste.clientWidth;
      var x = Math.round(piste.scrollLeft);
      prec.disabled = x <= 2;
      suiv.disabled = x >= course - 2;
    }

    function aller(sens, bouton) {
      var enjambee = pas(piste);
      var course = piste.scrollWidth - piste.clientWidth;
      var cible = piste.scrollLeft + sens * enjambee;

      piste.scrollBy({
        left: sens * enjambee,
        behavior: MOINS_DE_MOUVEMENT.matches ? 'auto' : 'smooth'
      });

      /* Si le bouton cliqué est sur le point de devenir inactif, on passe le
         focus à son voisin : un utilisateur au clavier ne doit pas se
         retrouver sur un bouton désactivé. */
      var deviendraInactif = sens > 0 ? cible >= course - 2 : cible <= 2;
      if (deviendraInactif && document.activeElement === bouton) {
        (bouton === suiv ? prec : suiv).focus();
      }
    }

    prec.addEventListener('click', function () {
      aller(-1, prec);
    });
    suiv.addEventListener('click', function () {
      aller(1, suiv);
    });

    piste.addEventListener('scroll', maj, { passive: true });

    /* Le passage du rail à la grille, ou une rotation d'écran, change ce
       qu'il reste à faire défiler. On observe la piste elle-même plutôt que
       la fenêtre : l'observateur se déclenche après la mise en page, alors
       qu'un écouteur de resize peut lire des dimensions encore périmées. */
    if (typeof ResizeObserver === 'function') {
      new ResizeObserver(maj).observe(piste);
    } else {
      window.addEventListener('resize', maj);
    }

    maj();
  }

  function go() {
    document.querySelectorAll('[data-fh-rail]').forEach(brancher);
  }

  if (document.readyState !== 'loading') go();
  else document.addEventListener('DOMContentLoaded', go);

  /* L'éditeur de thème recharge une section sans recharger la page. */
  document.addEventListener('shopify:section:load', go);
})();
